import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import CandidatePage from './pages/CandidatePage'
import LoginPage from './pages/LoginPage'
import { GeneralLayoutPage } from './components/GeneralLayoutPage'
import DashboardPage from './pages/DashboardPage'
import FormCreationPage from './pages/FormCreationPage'
import MassUploadPage from './pages/MassUploadPage'
import CandidatesPage from './pages/CandidatesPage'
import FormsPage from './pages/FormsPage'
import SentFormsPage from './pages/SentFormsPage'
import CandidateDetailsPage from './pages/CandidateDetailsPage'
import ProfessionalManagersPage from './pages/ProfessionalManagersPage'
import FormOverviewPage from './pages/FormOverviewPage'
import SetPasswordPage from './pages/SetPasswordPage'
import SettingsPage from './pages/SettingsPage'
import UsersPage from './pages/UsersPage'
import SendReadyTestPage from './pages/SendReadyTestPage'
import ReadyTestIntakePage from './pages/ReadyTestIntakePage'

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/set-password"
            element={
              <ProtectedRoute allowMustChangePassword>
                <SetPasswordPage />
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/settings"
            element={
              <ProtectedRoute roles={['recruiter']}>
                <GeneralLayoutPage children={<SettingsPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute roles={['superuser']}>
                <GeneralLayoutPage children={<UsersPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<DashboardPage />} />
              </ProtectedRoute>
            }
          />
          <Route path="/recruiter"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<FormCreationPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<MassUploadPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/candidates"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<CandidatesPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<FormsPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/send-ready-test"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<SendReadyTestPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forms/:formUuid/overview"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<FormOverviewPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sentforms"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<SentFormsPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional-managers"
            element={
              <ProtectedRoute roles={['superuser']}>
                <GeneralLayoutPage children={<ProfessionalManagersPage />} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sentform/:sentFormUuid/candidate-details"
            element={
              <ProtectedRoute>
                <GeneralLayoutPage children={<CandidateDetailsPage />} />
              </ProtectedRoute>
            }
          />
          <Route path="/candidate/:formUuid" element={<CandidatePage />} />
          <Route path="/ready-test/:inviteUuid" element={<ReadyTestIntakePage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
